module.exports = __webpack_public_path__ + "static/media/error.303462fd.gif";